// vault-startdatei.js — welche Notiz die Vault beim Öffnen zeigt.
//
// Ohne gemerkte Stelle der Radiologie-Index; mit gemerkter Stelle die, an der
// die Nutzerin zuletzt war. Gemerkt wird nur für die Browsersitzung
// (sessionStorage): ein neues Fenster startet wieder beim Index.

export const STANDARD_NOTIZ = 'Systeme Radiologie.md';
/// Der einzige Ordner, den der Baum links zeigt. Geladen bleibt die ganze
/// Vault: Verweise, Suche und Bilder aus anderen Ordnern (z. B. `Bilder/`)
/// muessen weiter aufloesen, sie stehen nur nicht in der Liste.
export const SICHTBARER_ORDNER = 'Systeme Radiologie';
export const ALTE_STANDARD_NOTIZ = 'Mindpalace (Index).md';

// Obsidian-Pfade kommen je nach Betriebssystem mit / oder \.
function passt(pfad, gesucht) {
  if (pfad === gesucht) return true;
  const norm = (p) => p.replace(/\\/g, '/');
  const a = norm(pfad);
  const b = norm(gesucht);
  return a === b || a.endsWith('/' + b);
}

/// Der echte Pfad zu `gesucht` aus der Dateiliste, oder null.
export function findeDatei(dateien, gesucht) {
  if (!gesucht) return null;
  const treffer = (dateien || []).find((d) => d && d.path && passt(d.path, gesucht));
  return treffer ? treffer.path : null;
}

/// Die Notiz, mit der die Vault aufgeht: gemerkte Stelle, sonst der
/// Radiologie-Index, sonst der alte Mindpalace-Index. `null`, wenn die Vault
/// keine davon kennt — dann bleibt die leere Auswahlseite stehen.
export function startdatei(dateien, gemerkt) {
  return (
    findeDatei(dateien, gemerkt) ||
    findeDatei(dateien, STANDARD_NOTIZ) ||
    findeDatei(dateien, ALTE_STANDARD_NOTIZ)
  );
}

/// Was im Ordnerbaum erscheint: nur `Systeme Radiologie`. Gibt es den Ordner
/// in dieser Vault nicht, bleibt die Liste vollstaendig — lieber zu viel
/// zeigen als einen leeren Baum.
export function sichtbareDateien(dateien, ordner = SICHTBARER_ORDNER) {
  const liste = dateien || [];
  const drin = (d) => {
    const pfad = String((d && d.path) || '').replace(/\\/g, '/');
    return pfad === ordner || pfad.startsWith(ordner + '/');
  };
  const gefiltert = liste.filter(drin);
  return gefiltert.length > 0 ? gefiltert : liste;
}
